<template>
  <div class="home">
    <div class="bodyid">
      <div class="tobody">
        <div class="navbar">
          <div class="navbar-left">
            <img src="../assets/导航logo.png" />
            <div class="left-line"></div>
            <span>忘记密码</span>
          </div>
          <div class="navbar-right">
            <span @click="url">微炬云首页</span>
            <!-- <div class="right-line"></div> -->
            <span @click="urlHelp">帮助与文档</span>
            <div class="zixun">
              <span>咨询电话：</span><span>400-113-0200</span>
              <!-- <img class="zixun-img" src="../assets/咨询电话： 400-113-0200.png" alt=""> -->
            </div>
          </div>

        </div>
        <div class="zhuti">
          <div class="total">
            <div class="toggle">
              <div class="dian" @click="href">
                <div class="toggle-t">
                  <div class="juxing">返回登录</div>
                  <img src="../assets/返回.png" alt="">
                </div>
                <div class="title-t">找回密码</div>
              </div>
            </div>
            <div class="body">
              <div class="body-y">
                <el-form :label-position="labelPosition" :model="ruleForm" pattern="^\d{11}$" :rules="rules"
                  ref="ruleForm" label-width="80px" class="form-f">
                  <el-form-item prop="usernamee" style="margin-top: 2.0rem;" label="手机号码">
                    <el-input type="tel" v-model="ruleForm.usernamee" placeholder="请填写手机号"></el-input>
                  </el-form-item>
                  <el-form-item prop="passworde" label="新密码">
                    <el-input type="password" v-model="ruleForm.passworde" placeholder="请填写新密码"></el-input>
                  </el-form-item>
                  <el-form-item prop="passwordee" label="确认密码">
                    <el-input type="password" v-model="ruleForm.passwordee" placeholder="请填写确认密码"></el-input>
                  </el-form-item>
                  <el-form-item prop="sms" type="string" pattern="^\d{6}$" label="验证码" >
                    <el-input type="string" v-model="ruleForm.sms" placeholder="请输入短信验证码"></el-input>
                    <el-button @click.prevent="btnClickne" id="inpbtn" class="yzBtn">{{ btntitle }}</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button class="loginBtn" @click="ones">确 定</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button class="loginBtntwo">取 消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <!-- <div class="footer">
            <div class="footer-t">
              <ul>
                <li>
                  <a href="https://www.weijub.com/index/index/index">首页</a>
                </li>
                <li>|</li>
                <li>
                  <a href="https://www.weijub.com/index/index/product">微炬云产品</a>
                </li>
                <li>|</li>
                <li>
                  <a href="https://www.weijub.com/index/index/plan">行业解决方案</a>
                </li>
                <li>|</li>
                <li>
                  <a href="https://www.weijub.com/index/index/channel">渠道合作</a>
                </li>
                <li>|</li>
                <li>
                  <a href="https://www.weijub.com/index/index/news?category_id=15">营销干货</a>
                </li>
                <li>|</li>
                <li>
                  <a href="https://www.weijub.com/index/index/channel_center">渠道中心</a>
                </li>
                <li>|</li>
                <li>
                  <a href="https://www.weijub.com/index/index/about">关于我们</a>
                </li>
              </ul>
            </div>
            <div class="footer-b">Copyright © 2013-2023 www.weijub.com All Rights Reserved 上海微炬云企业发展有限公司版权所有
              沪ICP备20021369号-1</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Vue from "vue";
import { Area } from "vant";
import areaList from "../data/area.js";
import qs from "qs";
import md5 from "js-md5";
import logopath from "../filter/logopath.js";
import { provinceAndCityData, CodeToText } from "element-china-area-data";
export default {
  data() {
    return {
      usernamee: "", //手机号
      passworde: "", //新密码
      passwordee: "", //确认密码
      sms: "", //用户输入的验证码
      btntitle: "获取验证码",
      pattern: /(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^((\(\d{3}\))|(\d{3}\-))?(1[3456789]\d{9})$)/, //手机正则
      enterprise: "", //企业名称
      scale: "", //企业规模
      value: "",
      city: "",
      showArea: false,
      areaList, // 数据格式见 Area 组件文档areaList
      searchResult: [], //地址??????
      fileList: [], //图片url这边是用来接路径的，不能改，改就报错只能下面改成字符串
      text: "", // 详细地址
      utl: "", //图片地址后台返回的
      yam: "", //获取到的验证码
      cansend: true,
      timer: null,
      userdetailShow: false, //回车
      title: {},
      options: [],
      selectedOptions: [],
      ruleForm: {
        sjs: "",
        usernamee: "",
        passworde: "",
        passwordee: "",
        sms: ""
      },
      labelPosition: 'right',
      rules: {
        usernamee: [
          { required: true, message: '请填写正确的手机号', trigger: 'blur' }
        ],
        passworde: [
          { min: 6, max: 32, required: true, message: '密码不能少于6位', trigger: 'blur' }
        ],
        passwordee: [
          { min: 6, max: 32, required: true, message: '请确认密码', trigger: 'blur' }
        ],
        sms: [
          {
            required: true,
            message: '请与验证码保持一致',
            trigger: 'blur'
          }
        ],
      },
    };
  },
  filters: {
    logopath,
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    this.getAreaTreeList()
  },
  created: function () {
    var _this = this;
    document.onkeydown = function (e) {   //按下回车提交
      let key = window.event.keyCode;
      //事件中keycode=13为回车事件
      if (key == 13) {
        _this.ones();
      }
    };
  },
  methods: {
    //element 验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ones();
          //Toast(this.yzm);
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getAreaTreeList() {
      this.axios
        .post(
          "/api/Area/getAreaTreeList",
          qs.stringify({}),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          // console.log(res);
          this.options = res.data.data
        })
        .catch(function (err) { });
    },
    url() {
      location.href = "https://www.weijub.com";
    },
    urlHelp() {
      location.href = "https://www.weijub.com/index/index/help.html?id=59";
    },
    href() {
      location.href = "https://work.weijub.com/#/register"
    },
    aa() {
      this.$router.push("/register");
    },
    abcou() {
      this.ruleForm.sjs = Math.round(Math.random() * 100000000);
      var obj = this.ruleForm.sjs;
      this.imgCode = "https://api.weijub.com/api/user/newCode?id=" + obj + "";
    },
    btnClickne() {
      if (this.ruleForm.usernamee == "") {
        Toast("手机号码格式不能为空");
      } else {
        if (this.cansend) {
          this.cansend = false;
          // 发送请求
          this.axios
            .post(
              "/api/user/sendtel", //必须导入qs 加上qs.styingify
              qs.stringify({
                tel: this.ruleForm.usernamee,
                status: "2",
              }),
              // form表单提交方式
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((response) => {
              this.yam = response.data.data;
            })
            .catch(function (error) { });
          // 倒计时

          let countdown = 30;
          this.btntitle = countdown + "秒后重新发送";
          this.timer = setInterval(() => {
            countdown--;
            if (countdown <= 0) {
              clearInterval(this.timer);
              this.timer = null;
              this.btntitle = "重新发送";
              this.cansend = true;
            } else {
              this.btntitle = countdown + "秒后重新发送";
            }
          }, 1000);
        }
      }
    },
    ones() {
      this.abcou();
      if (this.ruleForm.passworde !== this.ruleForm.passwordee) {
        this.$message.error('两次密码不一致')
        return
      }
      this.axios
        .post(
          "/api/user/changeUserPassword", //必须导入qs 加上qs.styingify
          qs.stringify({
            phone: this.ruleForm.usernamee, //账号
            password: this.$md5(this.ruleForm.passworde), //密码
            code: this.ruleForm.sms
          }),
          // form表单提交方式
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            var Storuser = res.data.data;
            localStroage.setItem("storuser", JSON.stringify(Storuser));
            this.abcou();
            this.$router.replace("/register");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { });
    },
    afterRead(file) {
      // 这个是用来转的图片格式
      let cont = file.file;
      let data = new FormData(); //通过formdata上传
      data.append("file", cont);
      if (
        file.file.type == "image/png" ||
        file.file.type == "image/jpg" ||
        file.file.type == "image/jpeg"
      ) {
        this.axios
          .post("/api/index/uploads", data, {
            headers: {
              //表单图片的格式提交
              "content-type": "multer/form-data",
            },
          })
          .then((response) => {
            this.utl = response.data.data;
          })
          .catch(function (error) { });
      } else {
        Toast("图片格式必须为jpg，png，jpeg");
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.van-cell {
  display: flex;
  box-sizing: border-box;
  width: 34.0rem;
  position: relative;
  left: 8.0rem;
  padding: 1.2rem 1.6rem;
  overflow: hidden;
  color: rgba(0, 33, 105, 0.3);
  font-size: 1.4rem;
  background-color: #fff;
  border: .1rem solid rgba(0, 33, 105, 0.2);
}

::v-deep.el-input__inner {
  height: 6.0rem;
  line-height: 6.0rem;
}
</style>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}

#aa {
  width: 100%;
}

.aa {
  width: 15.6rem;
  height: 6.0rem;
  color: #fff;
}

.bodynav>h1 {
  color: #0078e6;
  font-size: 2.2rem;
  text-align: center;
}

.title {
  width: 100%;
  height: 10%;
}

.bodyid {
  width: 100%;
  height: 100%;
}

.tobody {
  height: 108.0rem;
  background: url('../assets/背景.png');
  background-size: 100% 100%;
}

.navbar {
  width: 100%;
  height: 6.0rem;
  padding: 2.6rem 5.0rem 0;
  color: #333;
  display: flex;
  justify-content: space-between;
}

.navbar-left {
  display: flex;
  align-items: center;
  line-height: 1;
  font-size: 1.2rem;
}

.navbar-left>img {
  width: 21.0rem;
  height: 2.9rem;
  margin-right: 3.0rem;
}


.left-line {
  width: .1rem;
  height: 1.7rem;
  background-color: #333333;
  margin: 2.2rem 1.0rem 2.2rem 0;
}

navbar-left>span {
  display: block;
  font-size: 1.2rem;
  margin-left: 3.0rem;
}

.navbar-right {
  display: flex;
  align-items: center;
  line-height: 1;
}
.navbar-right>span {
  display: block;
  font-size: 1.6rem;
  cursor: pointer;
  margin-right: 5.0rem;
}

.right-line {
  width: .1rem;
  height: 1.8rem;
  background-color: #fff;
  margin: 2.1rem 1.2rem;
}

.zixun {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22.2rem;
  height: 3.2rem;

  background: #49B372;
border-radius: .2rem;
}
.zixun>span:nth-child(2){font-size: 1.8rem;
font-family: DINAlternate-Bold, DINAlternate;
font-weight: bold;
color: #FFFFFF;
line-height: 2.1rem;}


.zixun>span:nth-child(1){

font-size: 1.6rem;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 2.2rem;
}

.zixun-img {
  width: 8.1rem;
  height: 3.0rem;
}

.zhuti {

background: rgba(255,255,255,0.8);
box-shadow: .0rem .2rem 2.0rem -.3rem rgba(0,0,0,0.2);
border-radius: 2.0rem;
backdrop-filter: blur(1.0rem);
margin: 3.5rem 21.0rem 9.5rem;
padding-bottom: 9.5rem;

}

.toggle {
  width: 100%;
  height: 15.4rem;
  margin-bottom: 4.0rem;
}

.dian {
  height: 3.0rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.toggle-t {
  height: 6.0rem;
  display: flex;
  justify-content: flex-end;
}

.toggle-t>img {
  width: 10.0rem;
  height: 10.0rem;
  border-radius: 0 2.0rem 0 0 ;
}

.juxing {


  background-image: url('../assets/矩形11.png');
  background-size: 100% 100%;
  margin: 3.0rem 0;
  position: relative;
  left: 1.5rem;
  width: 13.8rem;
height: 4.0rem;
/* background: #EEFFED; */
/* border: .1rem solid #49B372; */

font-size: 1.8rem;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #49B372;
line-height: 4.0rem;
text-align: center;

}

.title-t {

  text-align: center;
font-size: 4.2rem;
font-weight: 600;
color: #000000;
line-height: 5.9rem;
letter-spacing: .8rem;
margin-top: 3.5rem;
}

.zhuti .body {
  width: 100%;
  margin: 0 auto;
}


/* .form-f {
  margin: 0 38.6rem;

} */
.body-y{
  display: flex;
  justify-content: center;
}

.form-f>span {
  width: 6.0rem;
  color: #080A44;
  font-size: 1.4rem;
  text-align: right;
  display: inline-block;
  position: relative;
  right: .0rem;
  top: 3.3rem;
}

.footer {
  position: relative;
  top: 8.5rem;
}

.footer-t {
  color: #666666;
  font-size: 1.4rem;
}

.footer-t ul li a {
  color: #666;
}

.footer-t>ul {
  width: 75.0rem;
  margin: 10.0rem auto 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.footer-b {
  color: #333333;
  font-size: 1.2rem;
  text-align: center;
  margin-top: 1.0rem;
}

.yzBtn {
  display: inline-block;
  /* position: relative; */
  bottom: 6.0rem;
  /* left: 18.1rem; */
  background: linear-gradient(135deg, #bae0ff, #a2c5fe, 47%, #d1cfff);
}

#inpbtn {
  margin-top: -.1rem;
  padding:0 1.8rem !important;
height: 6.0rem;
background: #FFFFFF;
box-shadow: -.5rem .0rem 1.4rem -.9rem rgba(152,152,152,0.5);
border-radius: .4rem 1.0rem 1.0rem .4rem;
position: absolute;
    top: .1rem;
    border: .0rem;
    font-size: 2.2rem;
font-weight: 400;
color: #49B372;
line-height: 3.0rem;
}

.loginBtn {


  margin-top: 2.0rem;


  position: relative;

font-size: 2.2rem;

font-weight: 500;
color: #FFFFFF;
line-height: 3.0rem;
  width: 60.0rem;
height: 7.0rem;
background: #49B372 linear-gradient(136deg, rgba(255,255,255,0.1) 0%, #3A3C 100%);
box-shadow: .0rem .7rem 1.0rem .0rem rgba(73,179,114,0.5), .0rem -.7rem 1.0rem .0rem rgba(255,255,255,0.5);
border-radius: 1.0rem;
margin-left: 2.0rem;
  border: 0;
}
.loginBtn:hover,.loginBtn:focus{
  background: #49B372 linear-gradient(136deg, rgba(255,255,255,0.1) 0%, #3A3C 100%) !important;
  color: #FFFFFF !important;
}
.loginBtntwo {

  background: #fff;

  position: relative;
  width: 60.0rem;
height: 7.0rem;
border-radius: 1.0rem;
border: .2rem solid rgba(73,179,114,0.6);

font-size: 2.2rem;

font-weight: 500;
color: #49B372;
line-height: 3.0rem;
margin-left: 2.0rem;
}

::v-deep .el-form-item__content {
  margin-left: .0rem;
  display: flex;
  justify-content: flex-end;

}

::v-deep .el-form-item__content .el-input input {
  height: 6.0rem;
  display: inline-block;
}

::v-deep .el-form-item__content .el-button {
  font-size: 1.8rem;
}

#aa>>>.el-form-item__content {
  height: 6.0rem;
  background: #FFFFFF;
  width: 40.0rem;
}



::v-deep .form-f .el-form-item__label {
    height: 6.0rem;
    font-size: 2.2rem;
    font-weight: 400;
    line-height: 6.0rem;
    margin-right: 2.2rem;
    padding: .0rem;
}

::v-deep .form-f .el-input__inner {
  padding: 0 2.0rem !important;
  width: 60.0rem ;
height: 7.0rem ;
background: #FFFFFF ;
box-shadow: .0rem .4rem 1.6rem .0rem rgba(98,128,103,0.2) ;
border-radius: .8rem ;
font-size: 2.2rem;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #C5C9C5;
line-height: 3.0rem;
  border: none;
}
::v-deep .form-f .el-input{
  width:60.0rem;
}
::v-deep .el-form-item{
  margin-bottom:3.0rem;
}
</style>
